const CLASSNAMES = {
    STICKED: 'product-description-block__sticked',
};

/** @type {HTMLDivElement} */
const sdlHeaderElement = document.querySelector('.pdp_header_wrapper');

/** @type {HTMLDivElement} */
const productDescriptionElement = document.querySelector('.product-description-wrapper');

/** @type {HTMLDivElement} */
const findResellerElement = document.querySelector(
    '.product-description__price-section-partners-wrapper'
);

const hideSDLHeader = () => {
    sdlHeaderElement.style.opacity = 0;
};

const showSDLHeader = () => {
    sdlHeaderElement.style.opacity = 1;
};

function hideFindResellerElement() {
    if (
        document.querySelector('#add-to-cart') ||
        (document.querySelector('#download_btn__background') && findResellerElement)
    ) {
        findResellerElement.style.display = 'none';
    }
}

function showFindResellerElement() {
    if (
        document.querySelector('#add-to-cart') ||
        (document.querySelector('#download_btn__background') && findResellerElement)
    ) {
        findResellerElement.style.display = 'block';
    }
}

function setGlobalNotificationTopOffset(offset) {
    const apcGlobalNotification = document.querySelector('.apc-global-notification');
    if (apcGlobalNotification) {
        apcGlobalNotification.style.top = offset;
    }
}

/**
 * Show sticky product information
 * @param {number} additionalScrollHeight
 */
export const stickProductDescriptionBlock = additionalScrollHeight => {
    if (!sdlHeaderElement) {
        return;
    }
    /** Set height of description block for parent element
     * to prevent page layout from scrolling
     */
    const { height } = productDescriptionElement.getBoundingClientRect();
    productDescriptionElement.parentElement.style.height = `${height - additionalScrollHeight}px`;
    hideSDLHeader();
    productDescriptionElement.classList.add(CLASSNAMES.STICKED);
    hideFindResellerElement();
    setGlobalNotificationTopOffset('119px');
};

export const unstickProductDescriptionBlock = () => {
    if (!sdlHeaderElement) {
        return;
    }
    productDescriptionElement.parentElement.style.height = `auto`;
    showSDLHeader();
    productDescriptionElement.classList.remove(CLASSNAMES.STICKED);
    showFindResellerElement();
    setGlobalNotificationTopOffset('auto');
};

export const duplicatePartNumberForStickyHeader = () => {
    const productAvailabilityLabelsContainer = document.querySelector(
        '.product-availability-labels'
    );

    const element = document.querySelector('.product-description__part-number');

    if (element) {
        const duplicateElement = element.cloneNode(true);
        duplicateElement.removeAttribute('itemprop');

        productAvailabilityLabelsContainer.appendChild(duplicateElement);

        const GAP = document.createTextNode('\u00A0');
        productAvailabilityLabelsContainer.appendChild(GAP);
    }
};

export const duplicateLabelsForStickyHeader = () => {
    const productAvailabilityLabelsContainer = document.querySelector(
        '.product-availability-labels'
    );

    const duplicationConfig = [
        ['.product-description__stock-section', 'product-description__stock-section_sticked'],
        [
            '.product-description__discounted-section',
            'product-description__discounted-section_sticked',
        ],
        [
            '.product-description__stock-has-substitute',
            'product-description__stock-has-substitute_sticked',
        ],
    ];

    duplicationConfig.forEach(([selector, additionalClassName]) => {
        const element = document.querySelector(selector);

        if (element) {
            const duplicateElement = element.cloneNode(true);
            duplicateElement.removeAttribute('itemprop');

            duplicateElement.className = additionalClassName;

            productAvailabilityLabelsContainer.appendChild(duplicateElement);

            const GAP = document.createTextNode('\u00A0');
            productAvailabilityLabelsContainer.appendChild(GAP);
        }
    });
};
